<template lang="pug">
  parent
    data-table(v-bind="dataTableBinds")
      //-template(v-slot:item="{ item }")
        slot(name="item" :item="item")
      template(v-slot:item-name="{ item }")
        slot(name="item-name" :item="item")

      template(v-slot:table-actions)
        slot(name="table-actions")

      template(v-slot:table-top)
        slot(name="table-top")
</template>
<script>
import AbstractPage from './AbstractPage';
import DataTable from '../tables/DataTableAdvance';

export default {
  //extends: AbstractPage,
  components: { parent: AbstractPage, DataTable },

  props: {
    pageTitle: {
      type: String,
      defalut: null,
    },
    tableFilter: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tablePagination: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableHeaders: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableActions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableActionsFilters: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableItemActions: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableBinds: {
      type: Object,
      default: () => {
        return {};
      },
    },
    modName: {
      type: String,
      default: null,
    },
    showPlaceholder: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {
      showForm: null,
    };
  },

  computed: {
    showCustomPlaceholder() {
      // console.log("placeeee", this.showPlaceholder);
      return this.tableItems.length == 0 && this.showPlaceholder;
    },
    showFrm() {
      return this.showForm ?? this.showFormState;
    },
    showFormState() {
      return this.modName ? this.$store.state.forms[this.modName].show_form : false;
    },

    dataTableBinds() {
      return {
        tableFilter: this.tableFilter,
        tablePagination: this.tablePagination,
        tableHeaders: this.tableHeaders,
        tableItems: this.tableItems,
        tableActions: this.tableActions,
        tableItemActions: this.tableItemActions,
        tableActionsFilters: this.tableActionsFilters,
        title: this.pageTitle,
        modName: this.modName,
        ...this.tableBinds,
      };
    },
  },
};
</script>
